module.exports = __webpack_public_path__ + "static/media/Visa.fba3539f.png";